import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ApiService } from '@services/api.service';
import { environment } from '@env/environment';

import { PaginatedResultModel, PaginationSearchModel } from '@data-layer/models/common';
import { BrokerRequestModel } from '@app/modules/brokers-management/models';
import { ManagementBrokerModel } from '../models/management/brokers';

@Injectable({ providedIn: 'root' })
export class BrokersManagementRepository {
  constructor(private apiService: ApiService) {}

  public search(params: PaginationSearchModel): Observable<PaginatedResultModel<ManagementBrokerModel>> {
    return this.apiService.get<PaginatedResultModel<ManagementBrokerModel>>(
      `${environment.url.prefixCustoms}v2/management/brokers`,
      {
        params,
      },
      { isShowLoader: false },
    );
  }

  public get(id: number): Observable<ManagementBrokerModel> {
    return this.apiService.get<ManagementBrokerModel>(
      `${environment.url.prefixCustoms}v2/management/brokers/${id}`,
      {},
      { isShowLoader: true },
    );
  }

  public create(payload: BrokerRequestModel): Observable<ManagementBrokerModel> {
    return this.apiService.post<ManagementBrokerModel>(
      `${environment.url.prefixCustoms}v2/management/brokers`,
      payload,
      {},
      { isShowLoader: true },
    );
  }

  public update(id: number, payload: BrokerRequestModel): Observable<ManagementBrokerModel> {
    return this.apiService.put<ManagementBrokerModel>(
      `${environment.url.prefixCustoms}v2/management/brokers/${id}`,
      payload,
      {},
      { isShowLoader: true },
    );
  }

  public attachContact(brokerId: number, contactId: number): Observable<void> {
    return this.apiService.post<void>(
      `${environment.url.prefixCustoms}v2/management/brokers/${brokerId}/contacts/${contactId}`,
      {},
      {},
      { isShowLoader: true },
    );
  }

  public detachContact(brokerId: number, contactId: number): Observable<void> {
    return this.apiService.delete<void>(
      `${environment.url.prefixCustoms}v2/management/brokers/${brokerId}/contacts/${contactId}`,
      {},
      { isShowLoader: true },
    );
  }
}
